"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var ImageIcon = function ImageIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    viewBox: "0 0 20 20",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("title", null, "icon/image"), /*#__PURE__*/React.createElement("g", {
    id: "OCR",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/image",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\u77E9\u5F62",
    fill: "#000000",
    opacity: "0",
    x: "0",
    y: "0",
    width: "20",
    height: "20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8125001,2.91328125 L17.8125001,17.0867187 C17.8125001,17.2792397 17.736171,17.4639052 17.6000381,17.6000381 C17.4639052,17.736171 17.2792397,17.8125001 17.0867187,17.8125001 L2.91328125,17.8125001 C2.72077621,17.8125001 2.5361408,17.7361024 2.40001917,17.5999808 C2.26389755,17.4638592 2.18749997,17.2792238 2.18749997,17.0867187 L2.18749997,2.91328125 C2.18749997,2.72077621 2.26389755,2.5361408 2.40001917,2.40001917 C2.5361408,2.26389755 2.72077621,2.18749997 2.91328125,2.18749997 L17.0867187,2.18749997 C17.2792238,2.18749997 17.4638592,2.26389755 17.5999808,2.40001917 C17.7361024,2.5361408 17.8125001,2.72077621 17.8125001,2.91328125 Z",
    id: "\u8DEF\u5F84",
    fill: "#99E3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5316406,5.73730469 C11.5316406,6.60024961 12.2311957,7.29980469 13.0941406,7.29980469 C13.9570855,7.29980469 14.6566406,6.60024961 14.6566406,5.73730469 C14.6566406,4.87435977 13.9570855,4.17480469 13.0941406,4.17480469 C12.2311957,4.17480469 11.5316406,4.87435977 11.5316406,5.73730469 L11.5316406,5.73730469 Z",
    id: "\u8DEF\u5F84",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6916016,17.4880859 C17.557038,17.691011 17.3296196,17.8128633 17.0861328,17.8125008 L8.15292969,17.8125008 C8.16362058,17.7841064 8.17668775,17.7566654 8.19199219,17.7304687 L10.7837891,13.2408203 L12.5416016,10.1966797 C12.6385962,10.0286942 12.8178394,9.92521244 13.0118164,9.92521244 C13.2057934,9.92521244 13.3850366,10.0286942 13.4820312,10.1966797 L17.6916016,17.4880859 Z",
    id: "\u8DEF\u5F84",
    fill: "#4CCDEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3425781,17.8125 L2.91289063,17.8125 C2.72045327,17.8125 2.53591822,17.7359531 2.39988109,17.5998427 C2.26384395,17.4637323 2.18749997,17.2791561 2.18749997,17.0867187 L2.18749997,14.609375 L6.25957031,7.55664062 C6.53554687,7.07832031 7.22578125,7.07832031 7.50175781,7.55664062 L10.7830078,13.2402344 L13.2474609,17.5080078 C13.3017538,17.60102 13.3342732,17.7051221 13.3425781,17.8125 Z",
    id: "\u8DEF\u5F84",
    fill: "#E5F7FC"
  }))));
};
var _default = ImageIcon;
exports["default"] = _default;